// Import all Lee mascot images with correct paths and file extensions
import coffeeLeeImage from '../assets/images/thumbnails/cafelee.webp';
import beerLeeImage from '../assets/images/thumbnails/beerlee.webp';
import coworkLeeImage from '../assets/images/thumbnails/coworkinglee.webp';
import gymLeeImage from '../assets/images/thumbnails/gymlee.webp';
import foodCourtLeeImage from '../assets/images/thumbnails/foodcourtlee.webp';
import nightClubLeeImage from '../assets/images/thumbnails/nightclublee.webp';
import beachbarLeeImage from '../assets/images/thumbnails/beachbarlee.png';
import yogaLeeImage from '../assets/images/thumbnails/yogalee.webp';
import fastFoodLeeImage from '../assets/images/thumbnails/fastlee.webp';
import spaLeeImage from '../assets/images/thumbnails/spalee.png';
import clinincleeImage from '../assets/images/thumbnails/cliniclee.png';
import salonLeeImage from '../assets/images/thumbnails/salonlee.png';
import hotelLeeImage from '../assets/images/thumbnails/hotellee.webp';

// Default fallback image
import defaultLeeImage from '../assets/images/thumbnails/cafelee.webp';

// Mapping of venue industries to Lee mascot images
export const venueMascotMap = {
  // Food & Beverage
  'Cafe': coffeeLeeImage,
  'Coffee Shop': coffeeLeeImage,
  'Restaurant': foodCourtLeeImage,
  'Fast Food': fastFoodLeeImage,
  'Food Court': foodCourtLeeImage,
  'Bar': beerLeeImage,
  'Pub': beerLeeImage,
  'Night Club': nightClubLeeImage,
  'Nightclub': nightClubLeeImage,
  'Beach Club': beachbarLeeImage,
  'Beach Bar': beachbarLeeImage,
  
  // Work & Business
  'Coworking': coworkLeeImage,
  'Cowork': coworkLeeImage,
  'Business Center': coworkLeeImage,
  'Office': coworkLeeImage,
  
  // Health & Fitness
  'Gym': gymLeeImage,
  'Fitness': gymLeeImage,
  'Yoga': yogaLeeImage,
  'Yoga Studio': yogaLeeImage,
  'Spa': spaLeeImage,
  'Wellness': spaLeeImage,
  'Salon': salonLeeImage,
  'Beauty': salonLeeImage,
  
  // Healthcare
  'Clinic': clinincleeImage,
  'Hospital': clinincleeImage,
  'Medical': clinincleeImage,
  'Pharmacy': clinincleeImage,
  
  // Accommodation
  'Hotel': hotelLeeImage,
  'Resort': hotelLeeImage,
  'Hostel': hotelLeeImage,
  'Guesthouse': hotelLeeImage,
  
  // Default fallback
  'default': defaultLeeImage
};

// Function to get the appropriate Lee mascot for a venue
export const getVenueMascot = (venue) => {
  if (!venue) return defaultLeeImage;
  
  // Debug logging to see what data we're getting
  console.log('Venue data for mascot selection:', {
    name: venue.name,
    Industry: venue.Industry,
    allFields: Object.keys(venue)
  });
  
  // Try multiple field names that might contain venue type
  const industryFields = [
    venue.Industry,
    venue.industry,
    venue.type,
    venue.Type,
    venue.category,
    venue.Category,
    venue.venue_type,
    venue.Venue_Type
  ].filter(Boolean);
  
  // Try to match by any available industry field
  for (const industryField of industryFields) {
    if (!industryField) continue;
    
    const industry = industryField.toString().trim();
    
    // Direct match
    if (venueMascotMap[industry]) {
      console.log('Direct match found:', industry, '->', venueMascotMap[industry]);
      return venueMascotMap[industry];
    }
    
    // Case-insensitive match
    const lowerIndustry = industry.toLowerCase();
    for (const [key, value] of Object.entries(venueMascotMap)) {
      if (key.toLowerCase() === lowerIndustry) {
        console.log('Case-insensitive match found:', industry, '->', value);
        return value;
      }
    }
    
    // Enhanced partial matching with more variations
    if (lowerIndustry.includes('cafe') || lowerIndustry.includes('coffee') || lowerIndustry.includes('café')) {
      console.log('Partial match - Cafe:', industry, '->', coffeeLeeImage);
      return coffeeLeeImage;
    }
    if (lowerIndustry.includes('restaurant') || lowerIndustry.includes('dining') || lowerIndustry.includes('food')) {
      console.log('Partial match - Restaurant:', industry, '->', foodCourtLeeImage);
      return foodCourtLeeImage;
    }
    if (lowerIndustry.includes('bar') || lowerIndustry.includes('pub') || lowerIndustry.includes('lounge')) {
      console.log('Partial match - Bar:', industry, '->', beerLeeImage);
      return beerLeeImage;
    }
    if (lowerIndustry.includes('gym') || lowerIndustry.includes('fitness') || lowerIndustry.includes('workout')) {
      console.log('Partial match - Gym:', industry, '->', gymLeeImage);
      return gymLeeImage;
    }
    if (lowerIndustry.includes('yoga') || lowerIndustry.includes('pilates')) {
      console.log('Partial match - Yoga:', industry, '->', yogaLeeImage);
      return yogaLeeImage;
    }
    if (lowerIndustry.includes('cowork') || lowerIndustry.includes('office') || lowerIndustry.includes('workspace')) {
      console.log('Partial match - Cowork:', industry, '->', coworkLeeImage);
      return coworkLeeImage;
    }
    if (lowerIndustry.includes('hotel') || lowerIndustry.includes('resort') || lowerIndustry.includes('accommodation')) {
      console.log('Partial match - Hotel:', industry, '->', hotelLeeImage);
      return hotelLeeImage;
    }
    if (lowerIndustry.includes('spa') || lowerIndustry.includes('wellness') || lowerIndustry.includes('massage')) {
      console.log('Partial match - Spa:', industry, '->', spaLeeImage);
      return spaLeeImage;
    }
    if (lowerIndustry.includes('clinic') || lowerIndustry.includes('medical') || lowerIndustry.includes('hospital') || lowerIndustry.includes('health')) {
      console.log('Partial match - Clinic:', industry, '->', clinincleeImage);
      return clinincleeImage;
    }
    if (lowerIndustry.includes('salon') || lowerIndustry.includes('beauty') || lowerIndustry.includes('hair')) {
      console.log('Partial match - Salon:', industry, '->', salonLeeImage);
      return salonLeeImage;
    }
    if (lowerIndustry.includes('night') || lowerIndustry.includes('club') || lowerIndustry.includes('disco')) {
      console.log('Partial match - Night Club:', industry, '->', nightClubLeeImage);
      return nightClubLeeImage;
    }
    if (lowerIndustry.includes('beach') || lowerIndustry.includes('pool')) {
      console.log('Partial match - Beach Club:', industry, '->', beachbarLeeImage);
      return beachbarLeeImage;
    }
    if (lowerIndustry.includes('fast') || lowerIndustry.includes('quick') || lowerIndustry.includes('takeaway')) {
      console.log('Partial match - Fast Food:', industry, '->', fastFoodLeeImage);
      return fastFoodLeeImage;
    }
  }
  
  // If no match found, log and return default
  console.log('No match found for venue:', venue.name, 'Industry fields:', industryFields);
  return defaultLeeImage;
};

// Function to get venue type color based on industry
export const getVenueTypeColor = (venue) => {
  if (!venue) return '#f59e0b';
  
  // Try multiple field names
  const industryFields = [
    venue.Industry,
    venue.industry,
    venue.type,
    venue.Type,
    venue.category,
    venue.Category
  ].filter(Boolean);
  
  for (const industryField of industryFields) {
    if (!industryField) continue;
    
    const industry = industryField.toString().toLowerCase();
    
    if (industry.includes('cafe') || industry.includes('coffee')) return '#f59e0b';
    if (industry.includes('restaurant') || industry.includes('dining')) return '#ea580c';
    if (industry.includes('bar') || industry.includes('pub')) return '#92400e';
    if (industry.includes('gym') || industry.includes('fitness')) return '#ea580c';
    if (industry.includes('cowork') || industry.includes('office')) return '#f59e0b';
    if (industry.includes('hotel') || industry.includes('resort')) return '#b45309';
    if (industry.includes('spa') || industry.includes('wellness')) return '#b45309';
    if (industry.includes('clinic') || industry.includes('medical')) return '#b45309';
  }
  
  return '#f59e0b'; // Default orange
};
